export default {
    limpiarNombreRegion: (region) => {
        return region.replace(/(DEL |DE )/, "");
    },
    limpiarNombreRegionSimble: (region) => {
        if (region) {
            let filtroFormateado = region
            filtroFormateado = filtroFormateado.replace(/(DEL_|DE_)/, "");
            filtroFormateado = filtroFormateado.replace(/(Del |De )/, "");
            filtroFormateado = filtroFormateado.replace(/(_)/gi, " ");
            return filtroFormateado;
        }
    },
    limpiarNombreTipoInstitucion: (texto) => {
        if (texto) {
            let textoFormateado = texto
            textoFormateado = textoFormateado.replace(/(_)/gi, " ");
            return textoFormateado;
        }
    },
    criteriosOrdenCarreraTP: () => {
        let criteriorOrden = [
            {
                valor: "NOMBRE_CARRERA_ASCENDENTE",
                texto: "Nombre Carrera: A-Z"
            },
            {
                valor: "NOMBRE_CARRERA_DESCENDENTE",
                texto: "Nombre Carrera: Z-A"
            },
            {
                valor: "NOMBRE_INSTITUTO_ASCENDENTE",
                texto: "Instituciones: A-Z"
            },
            {
                valor: "NOMBRE_INSTITUTO_DESCENDENTE",
                texto: "Instituciones: Z-A"
            },
            {
                valor: "ARANCEL_ASCENDENTE",
                texto: "Menor Arancel"
            },
            {
                valor: "ARANCEL_DESCENDENTE",
                texto: "Mayor Arancel"
            },
            {
                valor: "DURACION_ASCENDENTE",
                texto: "Menor Duración Total"
            },
            {
                valor: "DURACION_DESCENDENTE",
                texto: "Mayor Duración Total"
            },
        ]
        return criteriorOrden;
    },
    criteriosOrdenCarreraUniv: () => {
        let criteriorOrden = [
            {
                valor: "NOMBRE_CARRERA_ASCENDENTE",
                texto: "Nombre Carrera: A-Z"
            },
            {
                valor: "NOMBRE_CARRERA_DESCENDENTE",
                texto: "Nombre Carrera: Z-A"
            },
            {
                valor: "NOMBRE_INSTITUTO_ASCENDENTE",
                texto: "Universidad: A-Z"
            },
            {
                valor: "NOMBRE_INSTITUTO_DESCENDENTE",
                texto: "Universidad: Z-A"
            },
            {
                valor: "ARANCEL_ASCENDENTE",
                texto: "Menor Arancel"
            },
            {
                valor: "ARANCEL_DESCENDENTE",
                texto: "Mayor Arancel"
            },
            {
                valor: "DURACION_ASCENDENTE",
                texto: "Menor Duración Total"
            },
            {
                valor: "DURACION_DESCENDENTE",
                texto: "Mayor Duración Total"
            },
        ]
        return criteriorOrden;
    },
    criteriosGratuidad: () => {
        let criterioGratuidad = [
            {
                valor: "ADSCRITA_GRATUIDAD",
                texto: "Adscritas"
            },
            {
                valor: "NO_ADSCRITA_GRATUIDAD",
                texto: "No Adscritas"
            },
            {
                valor: "TODAS",
                texto: "Todas"
            },
        ]
        return criterioGratuidad;
    },
    criteriosJornada: () => {
        let criterioJornada = [
            {
                valor: "DIURNO",
                texto: "Presencial Diurna"
            },
            {
                valor: "VESPERTINO",
                texto: "Presencial Vespertina"
            },
            {
                valor: "A_DISTANCIA",
                texto: "A Distancia"
            },
            {
                valor: "SEMIPRESENCIAL",
                texto: "Semipresencial"
            },
            {
                valor: "TODAS",
                texto: "Todas"
            },
        ]
        return criterioJornada;
    },
    criteriosTipoIntitucion: () => {
        let criterios = [
            {
                valor: "CENTRO_FORMACION_TECNICA",
                texto: "Centro de Formación Técnica"
            },
            {
                valor: "INSTITUTO_PROFESIONAL",
                texto: "Instituto Profesional"
            },
            {
                valor: "TODAS",
                texto: "Todas"
            }
        ]
        return criterios;
    },
    criterioBeneficiosDelEstado: () => {
        let criteriosBeneficios = [
            {
                valor: "GRATUIDAD_BECAS_Y_CREDITO",
                texto: "Gratuidad, Becas y Créditos"
            },
            {
                valor: "BECAS_Y_CREDITO",
                texto: "Becas y Créditos"
            },

            {
                valor: "SIN_BENEFICIOS_DEL_ESTADO",
                texto: "Sin Beneficios"
            },
            {
                valor: "TODOS",
                texto: "Todos"
            }
        ]
        return criteriosBeneficios;
    }
}


// WEBPACK FOOTER //
// ./src/utils/Busqueda.js